var t = require('i18n').t

module.exports = Em.Component.extend({
    helpUrl: function() {
        return t('annual_report.additional_info.missing_accounts.proceed_link')
    }.property()
})
